import styled from 'styled-components';

const RightBoxHeaderBar = styled.div`
  @media (max-width: 850px) {
    cursor: pointer;
  }
`;

export default RightBoxHeaderBar;
